define((require) => {
    "use strict";

    const FontIntegrationModel = require("editor/ui/settings/integrations/FontIntegrationModel");

    /**
     * Fonts.com integration model.
     *
     * @class FontsDotComIntegrationModel
     */
    return FontIntegrationModel.extend("FontsDotComIntegration", {

        defaults: {
            authenticationKey: undefined
        }
    }, {
        type: "FontsDotComIntegration"
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/integrations/FontsDotComIntegrationModel.js